import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/@Utils/amplitude";
import { INIT_SESSION, LOGIN } from "@Client/@Modules/main/store/account/account-actions";
import { mapActions, mapState } from "vuex";
import { showToast } from "@Shared/@Utils/constants";
import { decodeDetailsToken } from "@Client/@Utils/custom";
import PageLoader from "@Shared/components/loaders/page-loader.vue";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
import LoginPage from "@Shared/components/general/login-page.vue";
export default defineComponent({
  name: "LoginContainer",
  title() {
    return this.$t("sidebar.sections.login");
  },
  components: {
    LoginPage,
    PageLoader
  },
  props: {
    redirectPath: {
      type: String,
      default: "/"
    },
    paramsToken: {
      type: Boolean,
      default: false
    },
    detailsToken: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: true,
      buttonLoading: {
        loading: false,
        loadingStatus: true
      },
      clientDetails: {
        isGhost: false,
        emailFromShare: ""
      },
      path: window.location.pathname.replace("/", "").replace("#", "")
    };
  },
  computed: _objectSpread({}, mapState("AccountStore", ["token"])),
  beforeMount() {
    Amplitude.logEvent("Login - visited", {
      page: "login"
    });
  },
  async mounted() {
    this.loading = true;
    await this.loadTokenDetails();
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AccountStore", [LOGIN, INIT_SESSION])), {}, {
    handleExistingSessionLoginAttempt(emailSend) {
      const currentEmail = this.$auth.session.get().userDetails.email;
      if (currentEmail === emailSend) {
        return true;
      } else {
        this.$auth.session.end();
        return false;
      }
    },
    async handleLogin({
      email,
      password
    }) {
      if (this.token && this.handleExistingSessionLoginAttempt(email)) {
        window.location.reload();
        return;
      }
      this.buttonLoading.loading = true;
      const deviceConfig = (() => {
        try {
          const config = JSON.parse(localStorage.getItem("deviceInfo"));
          const deviceInfoEmail = config["email"];
          if (deviceInfoEmail === email.toLowerCase()) {
            return config["deviceInfo"];
          } else {
            localStorage.removeItem("deviceInfo");
            return null;
          }
        } catch (_unused) {
          return null;
        }
      })();
      const path = window.location.pathname.replace("/", "").replace("#", "");
      const sessionResult = await this.LOGIN({
        email,
        password,
        subdomain: path,
        deviceConfig: deviceConfig && deviceConfig["deviceKey"] ? deviceConfig : null
      });
      this.buttonLoading.loadingStatus = !isEmpty(sessionResult);
      this.buttonLoading.loading = false;
      if (!sessionResult) return;
      if (sessionResult.pendingEmailVerification) {
        showToast("info", "WelcomeAndVerifyEmail");
        return this.$router.replace({
          name: "registration-verify"
        });
      }
      if (sessionResult.deviceInfo) {
        localStorage.setItem("deviceInfo", _JSON$stringify({
          isTrustedDevice: false,
          email: sessionResult.userDetails.email.toLowerCase(),
          deviceInfo: sessionResult.deviceInfo
        }));
      }
      await this.INIT_SESSION(sessionResult);
      Amplitude.startSession(sessionResult);
      this.$router.push({
        name: "subdomain-interstitial",
        query: {
          force: sessionResult.showInterstitial,
          startUrl: this.redirectPath
        }
      });
    },
    async loadTokenDetails() {
      if (!this.paramsToken && !this.detailsToken) return;
      const {
        isGhost,
        emailFromShare
      } = await decodeDetailsToken({
        token: this.detailsToken,
        params: this.paramsToken
      });
      this.clientDetails = {
        isGhost,
        emailFromShare
      };
    }
  })
});